import { createQuery } from '@amzn/gsce-shared-react-lib';
import {
  ListReasonsCommand,
  type ListReasonsCommandInput,
} from '@amzn/gbsa-helios-typescript-client';
import { apiHeliosClient, withRetry } from '../../../shared/data';
import { AuditQueryKeys } from './keys';

/**
 * Fetches the configured reason list for a business unit + optional
 * division, filtered by category (NA_REASON, REOPEN_REASON, etc).
 *
 * Consumed by the perform-audit interaction for the NA-reason
 * picker — passes `category: ReasonCategory.NA_REASON` and gates
 * `enabled` on the audit's `divisionName`. Kept general here so a
 * future close-audit reason picker (REOPEN_REASON) can reuse the
 * same wrapper without a duplicate hook.
 *
 * Cache key is auto-mapped by `createQuery` as
 * [AuditQueryKeys.reasons, input] — the input's businessUnitId +
 * category + divisionName + activeOnly all participate. Two audits
 * in the same BU + division share the cache; different divisions
 * fetch independently.
 */
export const useListReasonsQuery = createQuery(
  AuditQueryKeys.reasons,
  (input: ListReasonsCommandInput) =>
    withRetry(() => apiHeliosClient.send(new ListReasonsCommand(input))),
);
